/**
 * Default value for alternative "other" in single and multiple select type questions
 */
export const other_option = "-1";
/**
 * Default value for alternative "not apply" in selection type questions
 */
export const no_apply_option = "-2"; 
/**
 * Values of conditions types for logics to show
 */
export const LogicToShowConditionsTypes = {
    ANSWER: 1,
    EXTRA_DATA: 2,
    QUANTITY: 3
}
/**
 * Selection type for double entry matrix questions
 */
export const matrix_selection_type_single = 1
export const matrix_selection_type_multi = 2